import { useMemo } from 'react';
import { useActiveEvacZonesQuery } from 'features/evacZones/hooks/useActiveEvacZonesQuery';
import { WildfireListItem } from 'features/wildfires/wildfire.types';
import { FloodingListItem } from 'features/flooding/flooding.types';
import { useIncidentFiltersState } from '../../../state/useIncidentFiltersState';
import { matchesFilters } from './useFilteredGeoEvents.utils';

type GeoEvent = WildfireListItem | FloodingListItem;

type UseFilteredGeoEventsProps<T extends GeoEvent> = {
  geoEvents: T[];
};

export const useFilteredGeoEvents = <T extends GeoEvent>(
  props: UseFilteredGeoEventsProps<T>,
): T[] => {
  const { geoEvents } = props;
  const { filters, filtersCount } = useIncidentFiltersState();
  const activeEvacZones = useActiveEvacZonesQuery();

  return useMemo(() => {
    if (filtersCount === 0) {
      return geoEvents;
    }

    const context = { activeEvacZones };

    return geoEvents.filter((geoEvent) =>
      matchesFilters(geoEvent, filters, context),
    );
  }, [geoEvents, filters, filtersCount, activeEvacZones]);
};
